import axios from 'axios'
import { message } from './reset-message'
import HttpStatus from './httpStatus'


// 设置全局请求头
// axios.defaults.headers.common['X-Requested-With'] = 'AJAX';
const config_env = require(`../build/${process.env.BUILD_ENV}.js`)
// 设置全局请求头
axios.defaults.headers.common['X-Requested-With'] = 'AJAX';
const service = axios.create({
    baseURL: config_env.BASE_URL,
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 120000,
})

service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor

service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
      try{
          const res = response.data;
          if (res.status && res.status != HttpStatus.OK) {
              if (res.status == HttpStatus.INVALID_TOKEN) {
                  reLogin(res.message);
              } else {
                  message({
                      message: res.message || '请求错误',
                      type: 'error',
                      duration: 5 * 1000
                  })
              }
              return res
          } else {
              return res
          }
      }catch (e){
        return Promise.reject(new Error(e || 'Error'))
      }
    },
    async error => {

        if (error.response.status === HttpStatus.INVALID_TOKEN) {
            reLogin();
        } else if (error.response.status === HttpStatus.FORBIDDEN) {
            message({
                message: error.response.data.message,
                type: 'error',
                duration: 5 * 1000
            })
        } else {
            let errMessage;
            if (error.message.includes('timeout')) {
                errMessage = '请求超时';
            } else {
                try {
                    errMessage = error.response.data.message;
                } catch (err) {
                    errMessage = '请求错误';
                }
            }
            message({
                message: errMessage,
                type: 'error',
                duration: 3 * 1000
            })

            return Promise.reject(error)
        }
    }
)

/**
 * 模拟休眠
 * @param time 毫秒
 * @returns {Promise}
 */
function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

/**
 * 重新登录
 */
function reLogin(msg) {
    message({
        message: msg || '当前会话已超时，请重新登录！',
        type: 'error',
        duration: 1 * 1000
    })
    localStorage.removeItem("1+XUserIdentity");
    localStorage.removeItem("1+XAdministration");
    sleep(1500).then(() => {
        location.reload()
    })
}

export default service
